import { map } from 'lodash';
import { createSelector } from 'reselect';

import { recognizedSendersByIdSelector } from '../common/selectors/recognized-senders-selectors';
import { rightPaneAttributesSelector } from '../common/selectors/right-pane-selectors';

import { mapRecognizedSender, senderSortFunc } from '../sender-details/selectors/sender-details-selectors';

export const recognizedSendersForADomain = createSelector(
    recognizedSendersByIdSelector,
    rightPaneAttributesSelector,
    ( recognizedSendersById, attributes ) => {
        const recognizedSendersMap = recognizedSendersById[attributes.domainName] || {};
        const sortedSenders = map( recognizedSendersMap, mapRecognizedSender ).sort( senderSortFunc );

        return sortedSenders;
    }
);

export const domainsForARecognizedSender = createSelector(
    recognizedSendersByIdSelector,
    rightPaneAttributesSelector,
    ( recognizedSendersById, attributes ) => {
        const domainsMap = recognizedSendersById[attributes.senderId] || {};
        const sortedDomains = map( domainsMap, mapRecognizedSender ).sort( senderSortFunc );

        return sortedDomains;
    }
);
